import React from 'react';

import { Badge } from '../../Badge';
import { Button } from '../../Button';
import { IconButton } from '../../IconButton';
import { DataGridToolbarAction } from '../types';

export interface DataGridToolbarActionButtonProps {
  action: DataGridToolbarAction;
  icon: React.ReactNode;
  label: string;
  isLabelVisible?: boolean;
}

const DataGridToolbarActionButton = ({
  action,
  icon,
  label,
  isLabelVisible = false,
}: DataGridToolbarActionButtonProps) => (
  <div className="flex items-center gap-xs">
    {isLabelVisible ? (
      <Button
        variant="secondary"
        size="sm"
        leftIcon={icon}
        onClick={action.onOpen}
      >
        {label}
      </Button>
    ) : (
      <IconButton
        variant="default"
        size="md"
        icon={icon}
        aria-label={label}
        onClick={action.onOpen}
      />
    )}
    {action.activeCount ? (
      <Badge variant="gray" size="sm">
        {action.activeCount}
      </Badge>
    ) : null}
  </div>
);

export { DataGridToolbarActionButton };
